import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { Link } from "react-router-dom";
import withCustomStyles from "./GProductCard.style";

// The single most reused component: rails, grids, search, "more like this".
// Order top→bottom: image tile → price → name → pack size → optional badge.
// The add control floats bottom-right of the tile (pass it as `action`).
const GProductCard = ({
  classes,
  className,
  to,
  onClick,
  image,
  name,
  price,
  wasPrice,
  discount,
  topBadge,
  packSize,
  badge,
  outOfStock,
  action,
  footer
}) => (
  <div
    className={classnames(
      classes.card,
      { [classes.isOut]: outOfStock },
      className
    )}
  >
    <div className={classes.tile}>
      <Link
        to={to}
        className={classes.imageLink}
        tabIndex={-1}
        onClick={onClick}
      >
        {image}
      </Link>
      {(discount || topBadge) && (
        <div className={classes.topLeft}>
          {discount && <span className={classes.discount}>{discount}</span>}
          {topBadge}
        </div>
      )}
      {outOfStock && <span className={classes.outLabel}>Out of stock</span>}
      {action && <div className={classes.action}>{action}</div>}
    </div>
    <div className={classes.priceRow}>
      <span className={classes.price}>{price}</span>
      {wasPrice && (
        <span className={classes.was}>
          <span className={classes.srOnly}>was </span>
          {wasPrice}
        </span>
      )}
    </div>
    <Link to={to} className={classes.name} onClick={onClick}>
      {name}
    </Link>
    {packSize && <span className={classes.pack}>{packSize}</span>}
    {badge}
    {footer && <div className={classes.footer}>{footer}</div>}
  </div>
);

GProductCard.propTypes = {
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  // fired when either product link (image or name) is clicked
  onClick: PropTypes.func,
  image: PropTypes.node,
  name: PropTypes.node.isRequired,
  price: PropTypes.node.isRequired,
  wasPrice: PropTypes.node,
  discount: PropTypes.node,
  topBadge: PropTypes.node,
  packSize: PropTypes.node,
  badge: PropTypes.node,
  outOfStock: PropTypes.bool,
  action: PropTypes.node,
  footer: PropTypes.node
};

export default withCustomStyles(GProductCard);
